import React, { useState, useEffect } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import Modal from '@mui/material/Modal'
import TextField from '@mui/material/TextField'
import { DataGrid, GridToolbar } from '@mui/x-data-grid'
import MenuItem from '@mui/material/MenuItem'
import { toast } from 'react-toastify'
import AddIcon from '@mui/icons-material/Add'
import 'react-toastify/dist/ReactToastify.css'
import Sidebar from '../sidebar'
import NavLogo from '../NavLogo'
import { Col, Row } from 'react-bootstrap'
import { MDBDataTable } from 'mdbreact'
import {
  BedAddApi,
  BedFindAllApi,
  BedUpdateData,
  BlockFindallApi,
  RoomFindAllApi,
  RoomFindAllByIdApi,
} from '../../ApiFile'
import axios from 'axios'
import Switch from '@mui/material/Switch'
import { notification } from 'antd'
import MobileNavbarAdmin from '../pages/MobileNavbarAdmin'

const Bed = () => {
  const [showModal, setShowModal] = useState(false)
  const [bedId, setBedId] = useState('')
  const [roomId, setRoomId] = useState('')
  const [blockId, setBlockId] = useState('')
  const [beds, setBeds] = useState([])
  const [rooms, setRooms] = useState([])
  const [blocks, setBlocks] = useState([])
  const [isEditing, setIsEditing] = useState(false)
  const [open, setOpen] = useState(false)
  const handleOpen = () => setOpen(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    fetchBedData()
    fetchBlockData()
  }, [])

  const fetchBedData = async () => {
    try {
      const response = await fetch(BedFindAllApi)
      if (!response.ok) {
        throw new Error('Failed to fetch bed data')
      }
      const data = await response.json()
      if (data === 'NOTFOUND') {
        setBeds([]) // Set rules to an empty array if "NOTFOUND"
      } else {
        const bedsWithId = data.map((bed, index) => ({ ...bed, id: index + 1 }))
        setBeds(bedsWithId)
      }
    } catch (error) {
      // console.error('Error fetching bed data:', error);
      setError('Failed to fetch bed data')
    }
  }

  // const fetchRoomData = async () => {
  //   try {
  //     const response = await fetch(RoomFindAllApi)
  //     if (!response.ok) {
  //       throw new Error('Failed to fetch room data')
  //     }
  //     const data = await response.json()
  //     setRooms(data)
  //   } catch (error) {
  //     setError('Failed to fetch room data')
  //   }
  // }

  const fetchRoomData = async (blockId) => {
  try {
    const response = await fetch(`${RoomFindAllByIdApi}/${blockId}`); // Assuming blockId is passed via query param
    if (!response.ok) {
      throw new Error('Failed to fetch room data');
    }
    const data = await response.json();
    setRooms(data);
  } catch (error) {
    setError('Failed to fetch room data');
  }
};


  const fetchBlockData = async () => {
    try {
      const response = await fetch(BlockFindallApi)
      if (!response.ok) {
        throw new Error('Failed to fetch block data')
      }
      const data = await response.json()
      setBlocks(data)
    } catch (error) {
      // console.error('Error fetching block data:', error);
      setError('Failed to fetch block data')
    }
  }

  // const handleToggle = async (bed_id, currentStatus) => {
  //   const newStatus = currentStatus === 0 ? 3 : 0
  //   try {
  //     await axios.put(BedUpdateData, {
  //       id: bed_id,
  //       flag: newStatus,
  //     })
  //     const updatedBeds = beds.map((item) =>
  //       item.bed_id === bed_id ? { ...item, status: newStatus } : item,
  //     )
  //     setBeds(updatedBeds)
  //   } catch (error) {
  //     console.error('Failed to update bed status:', error)
  //   }
  // }

  const handleToggle = async (bed_id,room_id,block_id, currentStatus) => {
  const newStatus = currentStatus === 0 ? 3 : 0;
  try {
    const response = await axios.put(BedUpdateData, {
      bed_id: bed_id,
      room_id: room_id,
      block_id: block_id,
      flag: newStatus,
    });

   if (response.data === 'UPDATED') {
      const updatedBeds = beds.map((item) =>
        item.bed_id === bed_id ? { ...item, status: newStatus } : item
      );
      setBeds(updatedBeds);
      fetchBedData();
    } else {
      // Handle case like "BEDNOTFOUND" or other messages
      alert(response.data);
    }
  } catch (error) {
    if (error.response && error.response.data) {
      alert(error.response.data); // Or use a toast/snackbar
    } else {
      console.error('Failed to update bed status:', error);
      alert('Something went wrong while updating bed status.');
    }
  }
};


  const handleCloseModal = () => setShowModal(false)
  // const handleShowModal = () => setShowModal(true);

  const savedata = async (e) => {
    e.preventDefault() // Prevent default form submission

     // Validation: check if any field is empty or null
  if (!bedId || !roomId || !blockId) {
    toast.warn('All fields are required!');
    return; // Stop execution if any field is missing
  }

    const formData = {
      bed_id: bedId,
      room_id: roomId,
      block_id: blockId,
    }
    axios
      .post(`${BedAddApi}`, formData)
      .then((response) => {
        if (response.data == 'SAVED') {
          fetchBedData()
          handleCloseModal()
          handleClose()
          toast.success('Bed added successfully')
        } else if (response.data == 'Already exist bed') {
          toast.warn('Bed Already Exist !!')
        } else if (response.data == 'ERROR') {
          handleCloseModal()
          handleClose()
          toast.error('Error occurred while saving data')
        }
      })
      .catch((error) => {
        console.error('Error uploading files:', error)
      })
  }

  const handleClose = () => {
    setOpen(false)
    setIsEditing(false)
    setBlockId('')
    setRoomId('')
    setBedId('')
  }

  const columns = [
    { label: 'Sr.No', field: 'srNo', sort: 'asc' },
    { label: 'Block Number', field: 'block_id', sort: 'asc' },
    { label: 'Room Number', field: 'room_id', sort: 'asc' },
    { label: 'Bed Number', field: 'bed_id', sort: 'asc' },
    { label: 'Inactive/Active', field: 'edit', sort: 'asc' },
  ]

  // const rows = beds.map((item, index) => ({
  //   srNo: index + 1,
  //   block_id: item.block_id,
  //   room_id: item.room_id,
  //   bed_id: item.bed_id,
  //   edit: (
  //     <Switch
  //       checked={item.flag === 0}
  //       onChange={() => handleToggle(item.bed_id,item.room_id,item.block_id,item.flag)}
  //       disabled={item.action === 1 || item.action === 2} // 🔒 Disable if action is 1 or 2
  //       color="primary"
  //     />
  //   ),
  // }))

  const rows = beds.map((item, index) => ({
  srNo: index + 1,
  block_id: item.block_id,
  room_id: item.room_id,
  bed_id: item.bed_id,
  edit: (
    <div onClick={() => handleClick(item)} style={{ display: 'inline-block' }}>
      <Switch
        checked={item.flag === 0}
        onChange={() => {}} // Prevent default behavior; we handle via wrapper
        disabled={false} // Always enabled visually
      />
    </div>
  ),
}))

  const handleClick = (item) => {
  if (item.action === 1 || item.action === 2) {
    notification.warning({
      message: 'Action Restricted',
      description: 'You cannot modify this bed due to its currently occupied',
    })
  } else {
    handleToggle(item.bed_id, item.room_id, item.block_id, item.flag)
  }
}

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  }

  return (
    <>
      <div className="roomchange-container" style={{ display: 'flex', minHeight: '100vh' }}>
                     {/* Sidebar on the left for desktop */}
                     <div className="d-none d-md-block sidebar-container" style={{ width: '270px', flexShrink: 0, }}>
                       <Sidebar />
                     </div>
               
                     {/* Main content on the right */}
                     <div className="main-content flex-grow-1" style={{ flex: 1, backgroundColor: '#f8f9fa'}}>
                       <NavLogo />
                   
                         <div className="d-block d-md-none">
                           <MobileNavbarAdmin />
                         </div>

          <div className="border w-100 h-100 py-3" style={{backgroundColor:"#f5f5f5ff"}}>
          <div className="row m-0 block-header ps-3">
          <div className='col-12 col-md-6'>
            <h5 className="room-change-title text-start mt-md-4 mt-2" style={{ color: '#0783d6' }}>
               Bed Master
            </h5>
            </div>
            <div className='col-12 col-md-6 text-end'>
              <Button
              className="ms-md-4 ms-2  mb-2 mb-md-4 mt-2"
              variant="contained"
              color="primary"
              onClick={handleOpen}
              startIcon={<AddIcon />}
            >
              Add Bed
            </Button>
            </div>
          </div>

          <Row
            className="m-0 p-0  px-md-3 py-1 pb-5 w-100"
            style={{ display: 'flex' }}
          >
            <Row className="m-0 pt-1 px-2 px-md-3 rounded">
              <Col
                className="m-0 p-0 px-3 py-3 rounded mb-5 shadow"
                style={{ background: 'white' }}
              >
                <div style={{ overflowY: 'auto' }}>
                  <div style={{ overflowX: 'auto' }}>
                    <MDBDataTable
                      striped
                      className="custom-datatable"
                      bordered
                      hover
                      data={{ columns, rows }}
                    />
                  </div>
                </div>
              </Col>
            </Row>

            <Modal
              open={open}
              onClose={handleClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style}>
                <Typography variant="h6" component="h2" gutterBottom>
                  Add Bed
                </Typography>
                <form>
                  <TextField
                    select
                    label="Block Number"
                    value={blockId}
                    // onChange={(e) => setBlockId(e.target.value)}
                    onChange={(e) => {
                    const selectedBlockId = e.target.value;
                    setBlockId(selectedBlockId);
                    fetchRoomData(selectedBlockId); // Fetch rooms based on selected block
                    setRoomId(""); // Clear previous room selection
                  }}
                    fullWidth
                    style={{ marginBottom: '20px' }}
                  >
                    {blocks.map((block) => (
                      <MenuItem key={block.block_id} value={block.block_id}>
                        {block.block_id}
                      </MenuItem>
                    ))}
                  </TextField>

                  <TextField
                    select
                    label="Room Number"
                    value={roomId}
                    onChange={(e) => setRoomId(e.target.value)}
                    fullWidth
                    style={{ marginBottom: '10px' }}
                  >
                    {rooms.map((room) => (
                      <MenuItem key={room.room_id} value={room.room_id}>
                        {room.room_id}
                      </MenuItem>
                    ))}
                  </TextField>

                  <TextField
                    label="Bed Number"
                    value={bedId}
                    type='number'
                    onChange={(e) => setBedId(e.target.value)}
                    fullWidth
                    style={{ marginBottom: '10px' }}
                  />
                </form>
                <Row>
                  <Col className="text-end">
                    <Button
                      className="mt-4"
                      style={{
                        color: 'black',
                        backgroundColor: 'white',
                        border: '2px solid #9ce3ff',
                        borderRadius: '8',
                      }}
                      onClick={handleClose}
                    >
                      Cancel
                    </Button>
                  </Col>
                  <Col>
                    {isEditing ? (
                      <Button
                        style={{
                          border: '0px',
                          backgroundColor: '#9ce3ff',
                        }}
                        className="py-2 px-3 mt-4 shadow text-dark"
                        type="submit"
                        onClick={savedata}
                      >
                        Update
                      </Button>
                    ) : (
                      <Button
                        style={{
                          border: '0px',
                          backgroundColor: '#9ce3ff',
                        }}
                        className="py-2 px-3 mt-4 shadow text-dark"
                        type="submit"
                        onClick={savedata}
                      >
                        Save
                      </Button>
                    )}
                  </Col>
                </Row>
              </Box>
            </Modal>
          </Row>
        </div>
      </div>
      </div>
    </>
  )
}

export default Bed
